let collectionFilter = document.getElementById("collectionFilter");
let languageFilter = document.getElementById("languageFilter");
let sortSelect = document.getElementById("sortProducts");

let productCards = document.querySelectorAll(".product-card");

// 🔥 COMBINED FILTER FUNCTION
function applyFilters() {

    let selectedCollection = collectionFilter.value.toLowerCase();
    let selectedLanguage = languageFilter.value.toLowerCase();

    productCards.forEach((item) => {

        const tags = item.dataset.tags ? item.dataset.tags.split(',') : [];
        const collections = item.dataset.collections ? item.dataset.collections.split(',') : [];

        let collectionMatch = !selectedCollection || collections.includes(selectedCollection);
        let languageMatch = !selectedLanguage || tags.includes(selectedLanguage);

        if (collectionMatch && languageMatch) {
            item.style.display = "block";
        } else {
            item.style.display = "none";
        }

    });

    applySorting(); // apply sorting after filtering
}

// 🔥 SORT FUNCTION (same logic improved)
function applySorting() {

    let type = sortSelect.value;
    let grid = document.getElementById("productGrid");

    let visibleCards = [...grid.querySelectorAll(".product-card")]
        .filter(card => card.style.display !== "none");

    visibleCards.sort((a, b) => {

        let priceA = parseFloat(a.dataset.price);
        let priceB = parseFloat(b.dataset.price);

        if (type == "price-ascending") return priceA - priceB;
        if (type == "price-descending") return priceB - priceA;

        if (type == "title-ascending") return a.dataset.title.localeCompare(b.dataset.title);
        if (type == "title-descending") return b.dataset.title.localeCompare(a.dataset.title);
        
        if (type == "latest") {
    let dateA = parseInt(a.dataset.date || 0);
    let dateB = parseInt(b.dataset.date || 0);
    return dateB - dateA;
}
    });

    visibleCards.forEach(card => grid.appendChild(card));
}

// EVENTS
collectionFilter.addEventListener("change", applyFilters);
languageFilter.addEventListener("change", applyFilters);
sortSelect.addEventListener("change", applySorting);